<template>
<div>
<div class="modal" id="fiscalPrinter" data-backdrop="static" data-keyboard="false" tabindex="-1"  role="dialog">
<div class="modal-dialog modal-dialog-centered modal-lg"  role="document">

  <component v-bind:data="data" @close="close()" v-bind:is="data.component"  v-if="data.component" />
 
</div>
</div>
</div>

</template>

<script>


/* PAY YOUR ATTENTION PLEASE ... DO NOT CHANGE COMPONENT NAME */

/* EPSON */
import epsonCreditNote          from '@/components/rt/EpsonCreditNote.vue'
import epsonFiscalReceipt       from '@/components/rt/EpsonFiscalReceipt.vue'
import epsonGiftReceipt         from '@/components/rt/EpsonGiftReceipt.vue'
import epsonNotFiscalReceipt    from '@/components/rt/EpsonNotFiscalReceipt.vue'

/* RCH */
import rchFiscalReceipt         from '@/components/rt/RchFiscalReceipt.vue'
import rchCreditNote            from '@/components/rt/RchCreditNote.vue'
import rchGiftReceipt           from '@/components/rt/RchGiftReceipt.vue'

/* RETAIL */
import retailFiscalReceipt      from '@/components/rt/RetailFiscalReceipt.vue'
import retailGiftReceipt        from '@/components/rt/RetailGiftReceipt.vue'

export default {

  props : ['data'],

  components: {epsonCreditNote,epsonFiscalReceipt,epsonGiftReceipt,epsonNotFiscalReceipt,
              rchFiscalReceipt,rchGiftReceipt,rchCreditNote,
              retailFiscalReceipt,retailGiftReceipt},
  data() {
    return {     
            
    };
  },
   
  created () 
    { 
      this.$nextTick(()  => {                  
        $('#fiscalPrinter').modal('show')
        
    })   
          
    },  
  methods: 
    {
   
    close()
    {  
      $('#fiscalPrinter').modal('hide')
      this.$nextTick(()  => {              
        this.$emit('close')        
      })    

      
    },

   
  }
    
   
}


</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;  
}



.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}


.modal-footer {  
  justify-content: space-between;  
}
</style>


